<template>
  <div id="Feb2025" class="202502 bg-center">
    <div class="">
      <img src="~@/assets/images/202502/banner.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202502/m/banner.png" class="object-contain mx-auto md:hidden">
    </div>
    <a class="block" href="https://store.liveabc.com/products/magazine/sale?tag=455" target="_blank">
      <img src="~@/assets/images/202502/P1.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202502/m/P1.png" class="object-contain mx-auto md:hidden">
    </a>
    <a class="block" href="https://store.liveabc.com/products/magazine/sale?tag=456" target="_blank">
      <img src="~@/assets/images/202502/P2.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202502/m/P2.png" class="object-contain mx-auto md:hidden">
    </a>
    <a class="block" href="https://store.liveabc.com/products/magazine/sale?tag=457" target="_blank">
      <img src="~@/assets/images/202502/P3.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202502/m/P3.png" class="object-contain mx-auto md:hidden">
    </a>
    <div class="footer text-center py-6">
      <p>贈品數量有限，送完為止，若贈送完畢，得以等值贈品替換。</p>
      <p>活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>
      <router-link :to="{ name: 'index' }" class="block p-2" target="_blank">
        <img src="~@/assets/images/202502/logo.png" class="object-contain mx-auto">
      </router-link>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'October2024',
  metaInfo () {
    return {
      title: '2025年春季開學書展🏫｜滿額送好書①+①',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      bookData: [
        { id: 10235, img_url: require('@/assets/images/202501/book/1.png') },
        { id: 8461, img_url: require('@/assets/images/202501/book/2.png') },
        { id: 7455, img_url: require('@/assets/images/202501/book/3.png') },
        { id: 7801, img_url: require('@/assets/images/202501/book/4.png') },
        { id: 4658, img_url: require('@/assets/images/202501/book/5.png') },
        { id: 6573, img_url: require('@/assets/images/202501/book/6.png') },
        { id: 8158, img_url: require('@/assets/images/202501/book/7.png') },
        { id: 9669, img_url: require('@/assets/images/202501/book/8.png') },
        { id: 8973, img_url: require('@/assets/images/202501/book/9.png') },
        { id: 8737, img_url: require('@/assets/images/202501/book/10.png') },
        { id: 7732, img_url: require('@/assets/images/202501/book/11.png') },
        { id: 7649, img_url: require('@/assets/images/202501/book/12.png') }

      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#Feb2025 {
  background-color: rgb(154, 239, 206);
  .border-yellow-jan {
    border-color: #F7DD31;
  }

  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .toggle-btn {
    top: 20%;
    left: -50%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    left: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    left: -174px;
    transition: 0.3s;
  }

}

</style>
